export default {
  SET_LANG: "SET_LANG",
  SET_COUNTRY_LIST: "SET_COUNTRY_LIST",
  SET_TIMEZONE_LIST: "SET_TIMEZONE_LIST",
  SET_CURRENCY_LIST: "SET_CURRENCY_LIST",
  SET_FORM_DATA: "SET_FORM_DATA",
  SET_REGISTER_ID: "SET_REGISTER_ID",
  SET_LOGIN: "SET_LOGIN",
  SET_PROMOTION_SOURCE: "SET_PROMOTION_SOURCE",
  SET_SIGNATURE: "SET_SIGNATURE",
  SET_REGISTERED_EMAIL: "SET_REGISTERED_EMAIL",
  SET_ERROR_EMAIL: "SET_ERROR_EMAIL",
  SET_FORM_CONTENT_ID: "SET_FORM_CONTENT_ID",
  SET_REGISTER_SUBMITTING_STATE: "SET_REGISTER_SUBMITTING_STATE",
  SET_LEAVEINFO_SUBMITING_STATE: "SET_LEAVEINFO_SUBMITTING_STATE",
  SET_GOT_COOKIE: "SET_GOT_COOKIE",
  SET_LOGIN_INFO: "SET_LOGIN_INFO",
  SET_QUERY_REFER: "SET_QUERY_REFER",
  SET_LOGIN_CHECKED: "SET_LOGIN_CHECKED",
  SET_HAS_FETCH_LOGIN_INFO: "SET_HAS_FETCH_LOGIN_INFO",
  SET_FROM_REGISTER: "SET_FROM_REGISTER",
  SET_CUR_PAGE_NAME: "SET_CUR_PAGE_NAME",
  SET_EMAIL_MSG: "SET_EMAIL_MSG",
  SET_TOP_URL_SEARCH: "SET_TOP_URL_SEARCH",
  SET_LEAD_FORM_CONFIG: "SET_LEAD_FORM_CONFIG",
  SET_CUSTOM_IS_NEED_PHONE_NUMBER: "SET_CUSTOM_IS_NEED_PHONE_NUMBER",
  SET_USER_LOCATION: "SET_USER_LOCATION",
  SET_CLIENT_IP: "SET_CLIENT_IP",
  SET_NEED_COOKIE_BANNER: "SET_NEED_COOKIE_BANNER",
  SET_INIT_I18N_MESSAGE: "SET_INIT_I18N_MESSAGE",
  SET_ABTEST_CONFIG: "SET_ABTEST_CONFIG",
  SET_TTA_ID: "SET_TTA_ID",
  SET_ADV_INDUSTRY_LIST: "SET_ADV_INDUSTRY_LIST",
  SET_ADV_INDUSTRY_RETRY_TIMES: "SET_ADV_INDUSTRY_RETRY_TIMES",
  SET_USER_FILLED_DATA: "SET_USER_FILLED_DATA",
  SET_FORBIDDEN_ADV_INDUSTRY_IDS: "SET_FORBIDDEN_ADV_INDUSTRY_IDS",
  SET_KB_RENDER_READY: "SET_KB_RENDER_READY",
  SET_ADV_LIST: "SET_ADV_LIST",
  SET_CONTENTFUL_CONTENT_TYPE: 'SET_CONTENTFUL_CONTENT_TYPE',
  SET_ITEM_DIALOG: 'SET_ITEM_DIALOG',
  SET_SHOW_CHECK_ICON: 'SET_SHOW_CHECK_ICON',
  SET_REFERRAL_CODE_INFO: 'SET_REFERRAL_CODE_INFO',
  SET_GLOBAL_LOADING: 'SET_GLOBAL_LOADING',
  SET_CUSTOM_CONTENTFUL_CONTENT_TYPE: 'SET_CUSTOM_CONTENTFUL_CONTENT_TYPE',
  SET_IS_DYNAMIC_LP: 'SET_IS_DYNAMIC_LP',
  SET_IS_CASH_ACTIVE: 'SET_IS_CASH_ACTIVE',
  SET_DYNAMIC_LP_LIST: 'SET_DYNAMIC_LP_LIST',
  SET_ADV_ABTEST_CONFIG: 'SET_ADV_ABTEST_CONFIG',
  SET_INDEX_ABTEST_CONFIG: 'SET_INDEX_ABTEST_CONFIG',
  SET_SHOW_COPILOT: 'SET_SHOW_COPILOT',
  SET_COPILOT_LANG_WL: 'SET_COPILOT_LANG_WL',
  SET_CUSTOM_REDIRECTED_LINK: 'SET_CUSTOM_REDIRECTED_LINK',
};
